import React from 'react';
interface BadgeProps {
  status?: string;
  children: React.ReactNode;
}
export function Badge({
  status,
  children
}: BadgeProps) {
  // Comprehensive status color mapping based on Procure to Pay workflow
  const getStatusStyle = (status?: string): string => {
    // Handle undefined or null status
    if (!status) {
      return 'bg-gray-100 text-gray-700';
    }
    const normalizedStatus = status.toUpperCase();
    // Draft/Initial states - Amber
    if (normalizedStatus.includes('DRAFT') || normalizedStatus === 'SUBMITTED') {
      return 'bg-amber-100 text-amber-700';
    }
    // Pending/In Progress states - Blue
    if (normalizedStatus.includes('PENDING') || normalizedStatus.includes('IN PROGRESS') || normalizedStatus.includes('AWAITING') || normalizedStatus.includes('VALIDATING') || normalizedStatus.includes('MATCHING')) {
      return 'bg-blue-100 text-blue-700';
    }
    // Review states - Purple
    if (normalizedStatus.includes('REVIEW') || normalizedStatus.includes('IN REVIEW')) {
      return 'bg-purple-100 text-purple-700';
    }
    // Approved/Success states - Green
    if (normalizedStatus.includes('APPROVED') || normalizedStatus.includes('ACCEPTED') || normalizedStatus.includes('SUCCESS') || normalizedStatus.includes('MATCHED') || normalizedStatus.includes('ACTIVE') || normalizedStatus.includes('PAID') || normalizedStatus.includes('RECONCILED') || normalizedStatus.includes('CLOSED') || normalizedStatus === 'SENT TO VENDOR' || normalizedStatus === 'READY FOR PAYMENT') {
      return 'bg-green-100 text-green-700';
    }
    // Rejected/Failed/Error states - Red
    if (normalizedStatus.includes('REJECTED') || normalizedStatus.includes('FAILED') || normalizedStatus.includes('MISMATCH') || normalizedStatus.includes('EXCEPTION') || normalizedStatus.includes('DAMAGED') || normalizedStatus.includes('FRAUD') || normalizedStatus.includes('BLOCKED')) {
      return 'bg-red-100 text-red-700';
    }
    // Hold/Cancelled/Returned states - Gray
    if (normalizedStatus.includes('HOLD') || normalizedStatus.includes('CANCELLED') || normalizedStatus.includes('RETURNED') || normalizedStatus.includes('TERMINATED') || normalizedStatus.includes('ARCHIVED') || normalizedStatus.includes('EXPIRED')) {
      return 'bg-gray-200 text-gray-700';
    }
    // Partial states - Orange
    if (normalizedStatus.includes('PARTIAL')) {
      return 'bg-orange-100 text-orange-700';
    }
    // Received/Compliance states - Teal
    if (normalizedStatus.includes('RECEIVED') || normalizedStatus.includes('COMPLIANCE') || normalizedStatus.includes('AUDIT')) {
      return 'bg-teal-100 text-teal-700';
    }
    // Scheduled/Upcoming states - Indigo
    if (normalizedStatus.includes('SCHEDULED')) {
      return 'bg-indigo-100 text-indigo-700';
    }
    // Default - Gray
    return 'bg-gray-100 text-gray-700';
  };
  return <span className={`inline-block px-2 py-0.5 text-xs font-semibold rounded ${getStatusStyle(status)}`} data-id="element-2012">
      {children}
    </span>;
}